export interface GetWelcomeListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetWelcomeListPagingAndFilterResponseData
}

export interface GetWelcomeListPagingAndFilterResponseData {
    items: GetWelcomeListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetWelcomeListPagingAndFilterResponseItem {
    welcomeId: string
    companyId: string
    refNo: string
    customerId: string
    supplierId: string
    vehicleId: string
    trailerId: string
    containerNo: string
    driverId: string
    vehicleArriveDate: string
    customerName: string
    supplierName: string
    vehicleName: string
    trailerName: string
    driverName: string
    /** İşlem Durumu (listede rozet olarak gösterilir). */
    welcomeStatusName?: string
    createdDate: string
    welcomeDate: any
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
    ledgerNo: string | undefined
}

export const initialGetWelcomeListPagingAndFilterResponseData: GetWelcomeListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}